import React, {useCallback, useEffect, useState} from 'react';
import {KeyboardAvoidingView, Platform, View} from 'react-native';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../redux';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize} from '../../../shared/theme/helpers';
import {ProductsAcceptorFilterForm, ProductsCategoryFilterForm, ProductsPriceFilterForm} from '../filters/model';
import {ProductsListRequestPayload} from '../../../shared/models/api/productsListRequestPayload';
import {convertToIDArray} from '../filters/pipes';
import {setProductsByFilters} from '../../../redux/actions/products';
import Screen from '../../../shared/components/screen';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {ProductsCategoryFilter} from '../filters/productCategoryFilter';
import {ProductsAcceptorFilter} from '../filters/productAcceptorFilter';
import {ProductsPriceFilter} from '../filters/priceFilter';
import {getFormValues} from 'redux-form';
import {Forms} from '../../../shared/models/forms';
import {Button} from '../../../shared/components/button';
import {useNavigation} from '@react-navigation/native';

export type FilterState = {
  categoriesFilter: ProductsCategoryFilterForm;
  acceptorsFilter: ProductsAcceptorFilterForm;
  priceFilter: ProductsPriceFilterForm;
};

export function FiltersViewMobile() {
  const styles = useStyles(({mediaOnly, theme}) => ({
    root: {
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: 50,
    },
    container: {
      maxWidth: '95%',
      ...mediaOnly(DeviceSize.mobile, {margin: 'auto'}, {}),
      ...mediaOnly(DeviceSize.tablet, {marginTop: 10, marginLeft: 100}, {}),
      ...mediaOnly(DeviceSize.desktop, {marginTop: 10}, {}),
    },
    filterButtonContainer: {
      marginTop: 5,
      paddingVertical: 12,
      paddingHorizontal: 0,
      justifyContent: 'center',
      alignItems: 'center',
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
  }));

  const dispatch = useAppDispatch();
  const navigation = useNavigation();

  const [filter, setFilter] = useState<FilterState>({
    categoriesFilter: {
      productCategory: [],
    },
    acceptorsFilter: {
      productAcceptor: [],
    },
    priceFilter: {
      productPrice: [],
    },
  });
  const handleProductCategoryFilterApply = useCallback(
    (productCategory: any) => {
      setFilter((prevFilter) => ({...prevFilter, categoriesFilter: productCategory}));
    },
    [setFilter],
  );
  const handleProductAcceptorFilterApply = useCallback(
    (productAcceptor: any) => {
      setFilter((prevFilter) => ({...prevFilter, acceptorsFilter: productAcceptor}));
    },
    [setFilter],
  );
  const handleProductPriceFilterApply = useCallback(
    (productPrice: any) => {
      setFilter((prevFilter) => ({...prevFilter, priceFilter: productPrice}));
    },
    [setFilter],
  );

  const productAcceptorFormValues = useSelector(
    getFormValues(Forms.productsAcceptorFilterForm),
  ) as ProductsAcceptorFilterForm;

  const productCategoryFormValues = useSelector(
    getFormValues(Forms.productsCategoryFilterForm),
  ) as ProductsCategoryFilterForm;

  const productPriceFormValues = useSelector(getFormValues(Forms.productsPriceFilterForm)) as ProductsPriceFilterForm;

  let priceFrom: number | undefined;
  if (
    filter.priceFilter !== undefined &&
    filter.priceFilter.productPrice !== undefined &&
    filter.priceFilter?.productPrice[0] !== undefined
  )
    priceFrom = filter.priceFilter?.productPrice[0];

  let priceTo: number | undefined;
  if (
    filter.priceFilter !== undefined &&
    filter.priceFilter.productPrice !== undefined &&
    filter.priceFilter?.productPrice[1] !== undefined
  )
    priceTo = filter.priceFilter?.productPrice[1];

  const dataForBackEnd: ProductsListRequestPayload = {
    categoriesFilter: convertToIDArray(filter.categoriesFilter.productCategory ?? []),
    acceptorsFilter: convertToIDArray(filter.acceptorsFilter.productAcceptor ?? []),
    priceFilterFrom: priceFrom,
    priceFilterTo: priceTo,
  };

  const handlePressShow = () => {
    setFilter((prevFilter) => ({...prevFilter, acceptorsFilter: productAcceptorFormValues}));
    setFilter((prevFilter) => ({...prevFilter, categoriesFilter: productCategoryFormValues}));
    setFilter((prevFilter) => ({...prevFilter, priceFilter: productPriceFormValues}));
    Platform.OS !== 'web' && navigation.goBack();
  };

  useEffect(() => {
    dispatch(setProductsByFilters(dataForBackEnd));
  }, [filter]);

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
          <View style={styles.root}>
            <View style={styles.container}>
              <ProductsAcceptorFilter onFilterApply={handleProductAcceptorFilterApply} />
              <ProductsCategoryFilter onFilterApply={handleProductCategoryFilterApply} />
              <ProductsPriceFilter onFilterApply={handleProductPriceFilterApply} />
              <View style={[styles.filterButtonContainer]}>
                <Button
                  id='filter-show'
                  text='Показать'
                  type='secondary'
                  style={styles.filterButton}
                  onPress={handlePressShow}
                />
              </View>
            </View>
          </View>
        </KeyboardAvoidingView>
      </CustomScrollView>
    </Screen>
  );
}
